import { DottedSeparator } from "@/components/ui-kit/Decorations/DottedSeparator";
import { ImageWithSkeleton } from "@/components/ui-kit/ImageWithSkeleton";
import useSettingsProvider from "@/core/dataProviders/providers/app/useSettingsProvider";
import { AuthorListCardProps } from "@/types/modules/post/contentComponents";
import Link from "next/link";
import React, { useState } from "react";

export const AuthorListCard: React.FC<AuthorListCardProps> = ({ author }) => {
  const [settings, settingsReqState] = useSettingsProvider();
  const [hoveredBox, setHoveredBox] = useState(false);

  return (
    <Link
      href={author?.link}
      key={author.id}
      onMouseEnter={() => setHoveredBox(true)}
      onMouseLeave={() => setHoveredBox(false)}
    >
      <div className="flex items-center py-4 font-sans md:flex-col md:py-0">
        <div className="h-[100px] w-[75px] flex-shrink-0 md:h-[252px] md:w-[190px]">
          <ImageWithSkeleton
            src={author?.image?.url ?? settings?.authorFallbackImage ?? ""}
            alt={author?.name ?? ""}
            width={190}
            height={252}
            className="h-full w-full flex-shrink-0 object-cover"
            isHovered={hoveredBox}
          />
        </div>
        <div className="md:align-center ml-[16px] flex w-full flex-col justify-between md:ml-0 md:mt-[12px] md:justify-center md:text-center">
          <span
            className={`font-condensed text-xl no-underline decoration-1 underline-offset-4 transition-colors ease-in-out visited:text-dark-visited hover:decoration-dark-70 dark:text-white sm:text-2xl md:underline ${
              hoveredBox ? "decoration-dark-70 dark:decoration-white-50" : "decoration-transparent"
            }`}
          >
            {author?.name}
          </span>
          <p className="font-condensed text-sm font-light text-dark-70 dark:text-white-70 sm:text-base">
            {author?.jobTitle}
          </p>
        </div>
      </div>
      <div className="md:hidden">
        <DottedSeparator />
      </div>
    </Link>
  );
};
